<template>
  <div>
    <!-- <BreadcrumbBanner :pageTitle="$t('Profile')" :links="[]" /> -->
    <!--sign in-->
    <div class="signin-section pt-60 pb-60">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <!--this is log in-->
            <div class="opent-code ss">
              <div class="popup-container">
                <div class="register-from">
                  <div class="head">
                    <h2>{{ $t("Profile") }}</h2>
                    <p>
                      {{ $t("Fill out your profile for better experience") }}
                    </p>
                  </div>
                  <form @submit.prevent="onUpdateProfile">
                    <div class="items">
                      <div class="form-input">
                        <label for="name" class="form-label">{{
                          $t("Name")
                        }}</label>
                        <input
                          id="name"
                          name="name"
                          type="text"
                          v-model="name"
                          :placeholder="$t('Enter Your Name')"
                          required
                        />
                      </div>
                      <div class="form-input">
                        <label for="phone" class="form-label">{{
                          $t("Phone")
                        }}</label>
                        <input
                          id="phone"
                          name="phone"
                          type="tel"
                          v-model="phone"
                          :placeholder="$t('Enter Your Phone')"
                          disabled
                        />
                      </div>
                      <div class="form-input">
                        <label for="birth_date" class="form-label">{{
                          $t("Date of Birth")
                        }}</label>
                        <input
                          id="birth_date"
                          name="birth_date"
                          type="date"
                          v-model="birth_date"
                          :placeholder="$t('Enter Your Date of Birth')"
                          required
                        />
                      </div>
                      <div class="form-input">
                        <label for="email" class="form-label">{{
                          $t("Email")
                        }}</label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          v-model="email"
                          :placeholder="$t('Enter Your Email')"
                        />
                      </div>
                    </div>

                    <div class="items">
                      <button
                        type="submit"
                        class="cmn--btn cd-popup-close repopup"
                      >
                        <span>{{ $t("Update Profile") }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--sign in-->
  </div>
</template>

<script>
// import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import helpers from "@/helpers";

export default {
  name: "ProfilePage",
  components: {
    // BreadcrumbBanner,
  },
  data() {
    return {
      name: "",
      birth_date: "",
      phone: "",
      email: "",
    };
  },
  computed: {
    ...mapState(useAuthStore, ["userInfo"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["updateProfile"]),
    async onUpdateProfile() {
      console.log("onUpdateProfile called");
      // Add your code here
      await this.updateProfile(this.name, this.birth_date, this.email);
      helpers.showToast(
        this.$t("Profile updated successfully"),
        this.$t("Profile Updated"),
        "success"
      );
    },
  },
  mounted() {
    this.name = this.userInfo.name;
    this.birth_date = this.userInfo.birth_date;
    this.phone = "+" + this.userInfo.phone;
    this.email = this.userInfo.email;
  },
};
</script>
